import { ReduxAction } from 'app/redux/types';

import { Tab } from './constants';

// ---

export const SWITCH_ACTIVE_KEY = 'SIDEBAR:SWITCH_ACTIVE_KEY';

export type SwitchActiveKey = ReduxAction<
  typeof SWITCH_ACTIVE_KEY,
  { key: Tab }
>;

export const switchActiveKey = (key: Tab): SwitchActiveKey => ({
  type: SWITCH_ACTIVE_KEY,
  payload: { key },
});

// ---

export const SWITCH_TO_ALLOW_REFRESH_WARNING = 'SIDEBAR:SWITCH_TO_ALLOW_REFRESH_WARNING';

export type SwitchToAllowRefreshWarning = ReduxAction<typeof SWITCH_TO_ALLOW_REFRESH_WARNING, {
  value: boolean;
}>;

export const switchToAllowRefreshWarning = (value: boolean): SwitchToAllowRefreshWarning => ({
  type: SWITCH_TO_ALLOW_REFRESH_WARNING,
  payload: { value },
});
